export default {"src":"https://kroemtech.ch//_next/static/media/scygate_logo_white.ad02726a.svg","height":92,"width":425,"blurWidth":0,"blurHeight":0};